import React, { useContext } from 'react'
import CrudContext from 'components/platform/Crud/CrudContext'
import { Button } from 'components/platform/buttons/Button'
import { FormattedMessage } from 'react-intl'
import { CustomizeIcon } from '../../../config/icons'

export const ListActionButtons = () => {
  const { handleOpen, editableColumns, editableColumnsOpen } = useContext(CrudContext)
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <div>
        {editableColumns && (
          <Button color="outline-primary" onClick={() => editableColumnsOpen(true)}>
            <CustomizeIcon style={{ fontsize: 16 }} />{' '}
            <FormattedMessage id={'global.customize_columns'} />
          </Button>
        )}
      </div>
      <div>
        <Button aria-label="New" disabled={!handleOpen} onClick={() => handleOpen(0)} color="primary">
          <FormattedMessage id={'global.new'} />
        </Button>
      </div>
    </div>
  )
}
